import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDashboardCounts, getStatsArray } from './DashboardData';
import './index.scss';

const Dashboard = () => {
    const { counts, isLoading } = useDashboardCounts();
    const stats = getStatsArray(counts, isLoading);
    const navigate = useNavigate();

    const handleCardClick = (stat) => {
        const query = stat.filterKey ? `?${stat.filterKey}=${stat.filterValue}` : '';
        navigate(`/all-list${query}`);
    };

    return (
        <div className="dashboard-page">
            <h1 className="page-title">Dashboard</h1>

            <div className="stats-grid">
                {stats.map((stat, index) => (
                    <div
                        key={index}
                        className={`stat-card${stat.filterKey !== undefined ? ' stat-card--clickable' : ''}`}
                        style={{ borderTopColor: stat.color }}
                        onClick={() => handleCardClick(stat)}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => e.key === 'Enter' && handleCardClick(stat)}
                    >
                        <div className="stat-icon" style={{ background: `${stat.color}20` }}>
                            <span>{stat.icon}</span>
                        </div>
                        <div className="stat-content">
                            <h3 className={`stat-value ${isLoading ? 'loading' : ''}`}>
                                {stat.value}
                            </h3>
                            <p className="stat-title">{stat.title}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Dashboard;
